import { findWorkflow } from "@orchestration/definitions/registry/global-registry";
import { resolveActiveStatePath } from "@orchestration/runtime/active-state/active-state-paths";
import { readActiveWorkflowState } from "@orchestration/runtime/active-state/active-state-store";
import type { ActiveWorkflowState } from "@orchestration/runtime/active-state/active-state.types";
import type { WorkflowNotificationUi } from "./workflow-runtime.types";

// Constants for footer status
export const WORKFLOW_STATUS_KEY = "workflower";

export const WORKFLOW_STEP_STATUS_FORMAT = (workflowId: string, stepId: string): string =>
  `${workflowId} - ${stepId}`;

type WorkflowStatusContext = {
  cwd: string;
  ui: WorkflowNotificationUi;
  sessionManager: {
    getSessionId(): string;
  };
};

// Utility function to update workflow status in the footer
export function updateWorkflowStatus(
  ui: WorkflowNotificationUi,
  workflowId: string,
  stepId: string,
): void {
  if (ui.setStatus) {
    ui.setStatus(WORKFLOW_STATUS_KEY, WORKFLOW_STEP_STATUS_FORMAT(workflowId, stepId));
  }
}

// Utility function to clear workflow status from the footer
export function clearWorkflowStatus(ui: WorkflowNotificationUi): void {
  if (ui.setStatus) {
    ui.setStatus(WORKFLOW_STATUS_KEY, undefined);
  }
}

export async function syncActiveWorkflowStatus(ctx: WorkflowStatusContext): Promise<void> {
  let state: ActiveWorkflowState;
  try {
    state = await readActiveWorkflowState(
      resolveActiveStatePath(ctx.cwd, ctx.sessionManager.getSessionId()),
    );
  } catch {
    clearWorkflowStatus(ctx.ui);
    return;
  }

  const workflow = findWorkflow(state.id);
  const step = workflow?.steps[state.currentStepIndex];
  if (!workflow || !step) {
    clearWorkflowStatus(ctx.ui);
    return;
  }

  updateWorkflowStatus(ctx.ui, workflow.id, step.id);
}
